<template>
  <div id="accessory-addons">
    <div class="accessories-title">Accessory Addons</div>
    <div class="accessories-sub-title" v-if="is_fetching">
      <div class="d-flex ma-auto" style="width:fit-content">
        <v-progress-circular indeterminate/>
        <div class="mt-1 ml-2">Loading accessories...</div>
      </div>
    </div>
    <div class="accessories-sub-title" v-else-if="!copier.datasets || copier.datasets.length<1">(No accessories available for this product)</div>
    <div class="accessories-container pa-lg-5 pa-1" v-else>
      <v-row class="ma-0" density="compact">
        <v-col
          :class="`pa-1 ${DatasetsUncategorized().length===1?'mx-auto':''}`"
          v-for="dataset in DatasetsUncategorized()"
          :key="dataset.id"
          cols="12"
          :lg="columnsLG"
          :md="columnsMD"
          :sm="columnsSM">
          <div
            :class="['accessory-card', { 'is-selected': dataset.selected }]"
            :id="`dataset-id-${dataset.id}`">
            <div class="card-inner-content">
              <AccessoryName
                :dataset="dataset"
                :accessory="Accessory(dataset)">
                <template #actions>
                  <AccessoryButtons
                    :dataset="dataset"
                    :datasets="copier.datasets"
                    :accessory="Accessory(dataset)"
                    @select="$emit('SelectDataset',dataset)"
                    @unselect="$emit('UnselectDataset',dataset)"
                  />
                </template>
              </AccessoryName>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import AccessoryName from "@/components/configurator/AccessoryName.vue"
import AccessoryButtons from "@/components/configurator/AccessoryButtons.vue"

const props = defineProps<{
  copier: any,
  is_fetching: boolean,
}>()

defineEmits<{
  (e: 'SelectDataset', dataset: any): void
  (e: 'UnselectDataset', dataset: any): void
}>()

const store = useGlobalsStore()
const {
  config_drawer
} = storeToRefs(store)

const columnsLG = computed(() => {
  return config_drawer.value ? 3 : 3
})

const columnsMD = computed(() => {
  return config_drawer.value ? 4 : 6
})

const columnsSM = computed(() => {
  return config_drawer.value ? 6 : 12
})

function DatasetsUncategorized() {
  const datasetsList: any[] = []
  if (props.copier && props.copier.datasets && props.copier.instance) {
    props.copier.datasets.forEach((dataset: any) => {
      if (dataset.product_id == props.copier.instance.id) {
        datasetsList.push(dataset)
      }
    })
  }
  return datasetsList.slice().sort((a: any, b: any) => {
    const accessory_a = Accessory(a)
    const accessory_b = Accessory(b)
    if (!accessory_a || !accessory_b) return 0
    return accessory_a.name.localeCompare(accessory_b.name)
  })
}

function Accessory(dataset: any) {
  if (props.copier && props.copier.accessories) {
    return props.copier.accessories.find((accessory: any) => accessory.id === dataset.accessory_id)
  }
  return null
}

onMounted(() => {
  console.log(props.copier);

});
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.accessories-title {
  font-family: 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.accessories-sub-title {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  text-align: center;
  margin: 12px 0;
  color: #6b7280;
  font-style: italic;
}

.accessories-container {
  max-height: 520px;
  overflow-y: auto;
}

/* ── Redesigned Card ── */
.accessory-card {
  font-family: 'Inter', sans-serif;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
  word-break: break-word;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    border-color: #d1d5db;
  }

  &.is-selected {
    border-color: #10b981;
    background: #f0fdf4;
    box-shadow: 0 0 0 1px #10b981, 0 4px 12px rgba(16, 185, 129, 0.08);

    .accessory-image-wrapper {
      box-shadow: 0 0 0 2px #10b981;
    }
  }

  .card-inner-content {
    min-height: 52px;
  }
}

/* Dark Theme Compatibility Support */
.dark-theme .accessory-card,
.dark .accessory-card {
  background: #1e1e2d;
  border-color: #2d2d3f;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);

  &:hover {
    border-color: #3b3b55;
    box-shadow: 0 8px 24px rgba(0,0,0,0.3);
  }

  &.is-selected {
    background: #152e25;
    border-color: #10b981;
    box-shadow: 0 0 0 1px #10b981, 0 4px 16px rgba(16, 185, 129, 0.15);
  }
}
</style>
